import ClientCard from "@molecules/ObjectCard/ObjectCards/ClientCard/ClientCard"

import CardsView from "@organisms/ObjectsView/CardsView/CardsView"

export default function ClientCardsView() {
    return (
        <CardsView.List<Client>>
            {(client, displayedAttributes) => <ClientCard client={client} displayedAttributes={displayedAttributes} />}
        </CardsView.List>
    )
}
